"use client";

import { ToastContainer } from "react-toastify";
import { signatureToast } from "./signatureToast";

/**
 * Client wrapper around react-toastify's ToastContainer.
 *
 * The `transition` prop is a component produced by `cssTransition(...)`, which
 * must be created and consumed entirely on the client — passing it from the
 * Server root layout across the RSC boundary breaks the production build
 * ("Collecting page data" TypeError). Keeping both the container and the
 * transition inside this "use client" module isolates that concern.
 */
export function AppToastContainer() {
  return (
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={true}
      newestOnTop={true}
      closeOnClick={true}
      transition={signatureToast}
    />
  );
}
